<script setup lang="ts">
import MmDisclosure from '~/components/mm/base/MmDisclosure.vue';

import { onMounted, onUnmounted, ref } from 'vue'
defineProps<{ brief: string }>()
const { t } = useI18n()
const disclosure = ref<InstanceType<typeof MmDisclosure> | null>(null)
let openedByHover = false
const preview = (event: PointerEvent) => {
  const details = disclosure.value?.element
  if (event.pointerType !== 'mouse' || !details || details.open) return
  openedByHover = true
  details.open = true
}
const leave = () => {
  const details = disclosure.value?.element
  if (!openedByHover || !details || details.contains(document.activeElement)) return
  details.open = false
  openedByHover = false
}
let card: HTMLElement | null = null
onMounted(() => {
  card = disclosure.value?.element?.closest('article') || null
  card?.addEventListener('pointerenter', preview)
  card?.addEventListener('pointerleave', leave)
})
onUnmounted(() => {
  card?.removeEventListener('pointerenter', preview)
  card?.removeEventListener('pointerleave', leave)
})
</script>

<template>
  <MmDisclosure ref="disclosure" class="clips-template-preview" variant="divider" nested :label="t('clips.form.brief')" @focusout="leave" @click="openedByHover = false">
    <p>{{ brief }}</p>
  </MmDisclosure>
</template>
